import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { Comunidad, EmpleadoDto, Gremio, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, ExportMediaTypeConstants,
  SearchComunidadRequest, SearchEmpleadoAsistenciaRequestDto, SearchEmpleadoRequestDto, SearchGremioRequest, SearchMotivoInasistenciaRequest
 } from '../../../../../src/app/shared/model';
import { ComunidadService, EmpleadoService, GremioService, MenuFuncionService, MotivoInasistenciaService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-reporteAsistencias',
  templateUrl: 'reporteAsistencias.component.html',
  styleUrls: ['reporteAsistencias.component.scss']
})

export class ReporteAsistenciasComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  isGremiosSearching: boolean;
  isComunidadSearching: boolean = false;
  isEmpleadoSerching: boolean = false;
  isMotivoInasistenciaSearching: boolean = false;
  isSubContratistaSearching: boolean = false;
  canEdit: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;

  public query: Query;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  comunidadList: Comunidad[];
  filteredComunidadesList: Comunidad[];
  empleadoList: EmpleadoDto[];
  filteredEmpleadoList: EmpleadoDto[];
  selectedEmpleados: EmpleadoDto[] = new Array<EmpleadoDto>();
  asistenciasList: any[] = new Array<any>();
  selectedComunidades: Comunidad[] = new Array<Comunidad>();
  gremioList: Gremio[];
  motivoInasistenciaList: any[];
  filteredSubContratistaList: EmpleadoDto[];
  resultCount: number = 0;

  constructor(
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private formBuilder: FormBuilder,
    private empleadoService: EmpleadoService,
    private comunidadService: ComunidadService,
    private gremioService: GremioService,
    private motivoInasistencia: MotivoInasistenciaService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.REPORTE_ASISTENCIAS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.loadView();
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.data.executeQuery(this.query).then((result: any) => {this.resultCount = result.result.dateDistinctResult});
    this.grid.refresh();
  }

  loadView() {
    this.canView = true;

    this.buildForm();
    this.getComunidades();
    this.getEmpleados();
    this.getGremios();
    this.getMotivoInasistencia();
    this.getSubContratistas();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    /* this.getAsistenciaReporte(); */
    this.setQueryParams();
    this.data = new DataManager({
      url: this.empleadoService.getSearchAsistenciaUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.empleadoService.getAuthorizationHeader(), this.empleadoService.getTenantHeader()]
    });
    this.data.executeQuery(this.query).then((result: any) => {this.resultCount = result.result.dateDistinctResult});
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Comunidades': [null],
      'Empleados': [null],
      'Apellido': [null],
      'FechaDesde': [null],
      'FechaHasta': [null],
      'GremioId': [null],
      'MotivoInasistenciaId': [null],
      'SubContratista': [null],
      'Activo': [true],
      /* 'Cuit': [null], */
    });
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Comunidades");
    if (index >= 0)
      this.query.params[index].value = this.selectedComunidades?.map(x => x.Id.toString()).join(",");
    else
      this.query.addParams("Comunidades", this.selectedComunidades?.map(x => x.Id.toString()).join(","));

    index = this.query.params.findIndex(obj => obj.key === "Empleados");
    if (index >= 0)
      this.query.params[index].value = this.selectedEmpleados?.map(x => x.Id.toString()).join(",");
    else
      this.query.addParams("Empleados", this.selectedEmpleados?.map(x => x.Id.toString()).join(","));

     index = this.query.params.findIndex(obj => obj.key === "GremioId");
     if (index >= 0)
       this.query.params[index].value = this.searchForm.value.GremioId;
     else
       this.query.addParams("GremioId",this.searchForm.value.GremioId);

    index = this.query.params.findIndex(obj => obj.key === "MotivoInasistenciaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MotivoInasistenciaId;
    else
      this.query.addParams("MotivoInasistenciaId",this.searchForm.value.MotivoInasistenciaId);

    index = this.query.params.findIndex(obj => obj.key === "SubContratistaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.SubContratista?.Id;
    else
      this.query.addParams("SubContratistaId",this.searchForm.value.SubContratista?.Id);

    index = this.query.params.findIndex(obj => obj.key === "FechaDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaDesde", this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd");
    else
      this.query.addParams("FechaHasta", this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "Activo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Activo;
    else
      this.query.addParams("Activo", this.searchForm.value.Activo);

    /* index = this.query.params.findIndex(obj => obj.key === "Cuit");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Cuit;
    else
      this.query.addParams("Cuit", this.searchForm.value.Cuit); */
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  onExport() {
    const fechaDesde = this.datePipe.transform(this.searchForm.value.FechaDesde, "yyyy-MM-dd");
    const fechaHasta = this.datePipe.transform(this.searchForm.value.FechaHasta, "yyyy-MM-dd");
    const empleados = this.selectedEmpleados?.map(x => x.Id.toString()).join(",");
    const comunidades = this.selectedComunidades?.map(x => x.Id.toString()).join(",");

    var search = new SearchEmpleadoAsistenciaRequestDto(null, null, true, "FechaAsistencia", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);
    search.FechaDesde = fechaDesde;
    search.FechaHasta = fechaHasta;
    search.Comunidades = comunidades;
    search.Empleados = empleados;

    this.isExporting = true;
    this.empleadoService.exportAsistencias(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReporteAsistencias_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  getSubContratistas() {
    this.searchForm?.get("SubContratista")?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredSubContratistaList = [];
          this.isSubContratistaSearching = true;
        }),
        switchMap(value => this.empleadoService.search(new SearchEmpleadoRequestDto(50, null, true, "Nombre", null, null, null, (!isNumber(parseInt(value)) ? value : null), null, null, null, null, (isNumber(parseInt(value)) ? value : null), null, null, true, false))
          .pipe(
            finalize(() => {
              this.isSubContratistaSearching = false;
            }),
          )
        )
        )
        .subscribe((data: any) => {
          if (data != null && data.result != null)
            this.filteredSubContratistaList = data.result;
          else
            this.filteredSubContratistaList = [];
        });
  }

  getGremios() {
    var r = new SearchGremioRequest(null, null, null, null, null, null, null);
    this.isGremiosSearching = true;

    this.gremioService.search(r).subscribe(data => {
      this.isGremiosSearching = false;
      this.gremioList = data?.result;
    },
      (err: HttpErrorResponse) => {
        this.isGremiosSearching = false;
        this.sharedFunctions.handleError(err);
      })
  }

  getMotivoInasistencia() {
    var r = new SearchMotivoInasistenciaRequest(null, null, true, "Nombre", null, null, true);
    this.isMotivoInasistenciaSearching = true;

    this.motivoInasistencia.searchMotivoInasistencia(r).subscribe(data => {
      this.isMotivoInasistenciaSearching = false;
      this.motivoInasistenciaList = data?.result;
    },
      (err: HttpErrorResponse) => {
        this.isMotivoInasistenciaSearching = false;
        this.sharedFunctions.handleError(err);
      })
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
        this.filteredComunidadesList = this.comunidadList;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEmpleados() {
    this.searchForm.controls.Empleados.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredEmpleadoList = [];
        this.isEmpleadoSerching = true;
    }),
    switchMap(value => this.empleadoService.search(new SearchEmpleadoRequestDto(50, null, true, "Nombre", null, null, null, (!isNumber(parseInt(value)) ? value : null), null, null, null, null, (isNumber(parseInt(value)) ? value : null), null, null, false, true))
        .pipe(
        finalize(() => {
            this.isEmpleadoSerching = false;
        }),
        )
    )
    )
    .subscribe((data: any) => {
        if (data != null && data.result != null)
            this.filteredEmpleadoList = data.result;
        else
            this.filteredEmpleadoList = [];
    });
  }

  formatCuit(cuit: string): string {
    if (cuit?.length !== 11) {
      return cuit ?? '';
    }

    const regex = /^(\d{2})(\d{8})(\d{1})$/;
    const match = regex.exec(cuit);

    if (!match) {
      throw new Error('Invalid CUIT format');
    }

    const firstSegment = match[1];
    const secondSegment = match[2];
    const verificationDigit = match[3];

    const formattedCUIT = `${firstSegment}-${secondSegment}-${verificationDigit}`;

    return formattedCUIT;
  }

  // AutoComplete de Empleado ------------------>
 /*  filterEmpleadoList(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredEmpleadoList = this.empleadoList.filter(x =>
      x.Nombre.toLowerCase().includes(filterValue) ||
      x.Apellido.toLowerCase().includes(filterValue) ||
      (x.Apellido + " " + x.Nombre).toLowerCase().includes(filterValue) ||
      (x.Nombre + " " + x.Apellido).toLowerCase().includes(filterValue) ||
      x.Cuit.toString().includes(filterValue));
  } */

  empleadoSeleccionado(event: Event, empleado: EmpleadoDto) {
    event.stopPropagation();
    this.toggleEmpleado(empleado);
  }

  toggleEmpleado(empleado: any) {
    empleado.selected = !empleado.selected;
    if (empleado.selected) {
      this.selectedEmpleados.push(empleado);
    } else {
      const i = this.selectedEmpleados.findIndex(value => value.Id === empleado.Id);
      this.selectedEmpleados.splice(i, 1);
    }
    /* this.filteredEmpleadoList = this.empleadoList; */
    this.searchForm.get("Empleados")?.setValue(this.selectedEmpleados);
  }

  displayEmpleado(empleado: EmpleadoDto[] | string): string | undefined{
    let displayValue: string = "";

    if (Array.isArray(empleado)) {
      empleado.forEach((empleado, index) => {
        if (index === 0) {
          displayValue = empleado?.Nombre?.toUpperCase() + " " + empleado?.Apellido?.toUpperCase();
        } else {
          displayValue += ', ' + empleado?.Nombre?.toUpperCase() + " " + empleado?.Apellido?.toUpperCase();
        }
      });
    }
    else {
      displayValue = empleado;
    }

    return displayValue;
  }

  formatHintEmpleados(empleados: EmpleadoDto[]): string{
    return empleados.map(x => x?.Nombre?.toUpperCase() + " " + x?.Apellido?.toUpperCase()).join(", ");
  }

  // AutoComplete de Obras ------------------>
  filterComunidadList(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredComunidadesList = this.comunidadList.filter(x =>
      x?.Nombre?.toLowerCase().includes(filterValue));
  }

  comunidadSeleccionado(event: Event, comunidad: Comunidad) {
    event.stopPropagation();
    this.toggleComunidad(comunidad);
  }

  toggleComunidad(comunidad: any) {
    comunidad.selected = !comunidad.selected;
    if (comunidad.selected) {
      this.selectedComunidades.push(comunidad);
    } else {
      const i = this.selectedComunidades.findIndex(value => value.Id === comunidad.Id);
      this.selectedComunidades.splice(i, 1);
    }
    this.filteredComunidadesList = this.comunidadList;
    this.searchForm.get("Comunidades")?.setValue(this.selectedComunidades)
  }

  displayComunidad(comunidades: Comunidad[] | string): string | undefined{
    let displayValue: string = "";
    if (Array.isArray(comunidades)) {
      comunidades.forEach((comunidad, index) => {
        if (index === 0) {
          displayValue = this.sharedFunctions.formatComunidadName(comunidad);
        }
        else {
          displayValue += `, ${this.sharedFunctions.formatComunidadName(comunidad)}`;
        }
      });
    } else {
      displayValue = comunidades;
    }
    return displayValue;
  }

  formatHintComunidades(comunidades: Comunidad[]): string{
    return comunidades.map(x => this.sharedFunctions.formatComunidadName(x)).join(", ");
  }

  displaySubContratista(empleado: EmpleadoDto): string {
    return empleado && empleado?.Nombre || empleado?.Apellido ? (empleado.Apellido + ", " + empleado.Nombre).toUpperCase() + " - " + empleado.Cuit : '';
  }
}
